import { ProductListProductWithAccountRequestDto } from '@epicuro-next/data/engagement/engagement-models';
import { SearchSortType } from 'graphql-api/gql-api-interfaces';

import { extractProductByReferencesPayload } from '../extract-product-by-references-payload/extract-product-by-references-payload';

export function mapProductsQuery(
  productsQuery: ProductListProductWithAccountRequestDto,
) {
  const {
    productListId,
    site,
    start,
    num,
    available,
    productReferences,
    sortField,
  } = extractProductByReferencesPayload(productsQuery);

  const toSortByOrder =
    !!productListId &&
    productReferences.length > 1 &&
    sortField !== SearchSortType.Category;

  const commonQuery = {
    site,
    available,
    sortField,
    productReferences,
  };

  const paginateQuery = { ...commonQuery, start, num };

  if (sortField === SearchSortType.Category) {
    const payloadQuery = {
      ...paginateQuery,
      sortField,
    };

    return { payloadQuery, toSortByOrder };
  } else {
    return { payloadQuery: paginateQuery, toSortByOrder };
  }
}
